import { DividerContainer, DividerContent, DividerElement } from './style';

export type DividerVariant = 'vertical' | 'horizontal';

export interface DividerProps {
    children?: React.ReactNode;
    variant?: DividerVariant;
}

export const Divider = ({ children, variant = 'horizontal', ...other }: DividerProps) => (
    <DividerContainer variant={variant} {...other}>
        <DividerElement variant={variant} />
        {children ? <DividerContent>{children}</DividerContent> : null}
        <DividerElement variant={variant} />
    </DividerContainer>
);
